import React from 'react';
import '../assets/css/MissionVision.css';

const MissionVision = () => {
  return (
    <section id="about" className="mission-vision">
      <div className="container">
        <div className="vision">
          <div className="vision-content">
            <div className="icon-wrapper">
              <div className="vision-icon">👁️</div>
            </div>
            <h2>Our Vision</h2>
            <p>"To be the most trusted global partner for entrepreneurs and enterprises by delivering reliable, skilled, and fully managed Virtual Assistant solutions — empowering businesses to scale while creating sustainable careers for Filipino professionals."</p>
          </div>
        </div>
        
        <div className="mission">
          <div className="mission-header">
            <div className="icon-wrapper">
              <div className="mission-icon">🎯</div>
            </div>
            <h2>Our Mission</h2>
          </div>
          <ul>
            <li>
              <span className="mission-number">01</span>
              <div className="mission-text">
                <h4>Empower Businesses Worldwide</h4>
                <p>by providing dedicated and fully managed Virtual Assistants that help leaders focus on growth, not busywork.</p>
              </div>
            </li>
            <li>
              <span className="mission-number">02</span>
              <div className="mission-text">
                <h4>Elevate Filipino Talent</h4>
                <p>by creating meaningful, well-supported, and globally competitive career opportunities.</p>
              </div>
            </li>
            <li>
              <span className="mission-number">03</span>
              <div className="mission-text">
                <h4>Deliver Excellence</h4>
                <p>through a rigorous process of recruitment, training, and performance management.</p>
              </div>
            </li>
            <li>
              <span className="mission-number">04</span>
              <div className="mission-text">
                <h4>Ensure Trust & Transparency</h4>
                <p>with guaranteed quality service, clear reporting, and reliable backup support.</p>
              </div>
            </li>
            <li>
              <span className="mission-number">05</span>
              <div className="mission-text">
                <h4>Innovate Continuously</h4>
                <p>by leveraging technology and best practices to make remote staffing seamless and efficient.</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;